/**
 * Calendar helpers — aligned with app `src/utils/calendarDate.ts`.
 */

export function toLocalCalendarDate(d: string | Date): Date {
  if (typeof d === 'string') {
    const trimmed = d.trim();
    const dateOnly = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnly) {
      const y = parseInt(dateOnly[1], 10);
      const m = parseInt(dateOnly[2], 10) - 1;
      const day = parseInt(dateOnly[3], 10);
      return new Date(y, m, day);
    }
  }
  const date = typeof d === 'string' ? new Date(d) : d;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function calendarDateInTimeZone(d: string | Date, timeZone: string): Date {
  const instant = typeof d === 'string' ? new Date(d) : d;
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(instant);
  const y = parseInt(parts.find(p => p.type === 'year')?.value ?? '0', 10);
  const m = parseInt(parts.find(p => p.type === 'month')?.value ?? '1', 10) - 1;
  const day = parseInt(parts.find(p => p.type === 'day')?.value ?? '1', 10);
  return new Date(y, m, day);
}

export function startOfCalendarDayInTimeZoneMs(
  year: number,
  monthIndex: number,
  day: number,
  timeZone: string,
): number {
  const targetYmd = `${year}-${String(monthIndex + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const ymdFromUtc = (utcMs: number): string => {
    const parts = fmt.formatToParts(new Date(utcMs));
    const y = parts.find(p => p.type === 'year')?.value ?? '';
    const m = parts.find(p => p.type === 'month')?.value ?? '';
    const d = parts.find(p => p.type === 'day')?.value ?? '';
    return `${y}-${m}-${d}`;
  };
  let utcMs = Date.UTC(year, monthIndex, day, 12, 0, 0, 0);
  for (let i = 0; i < 96; i++) {
    const got = ymdFromUtc(utcMs);
    if (got === targetYmd) {
      while (utcMs > 0 && ymdFromUtc(utcMs - 60_000) === targetYmd) utcMs -= 60_000;
      return utcMs;
    }
    if (got < targetYmd) utcMs += 24 * 60 * 60 * 1000;
    else utcMs -= 24 * 60 * 60 * 1000;
  }
  return Date.UTC(year, monthIndex, day, 0, 0, 0, 0);
}
